/*=========================================================================================
  File Name: i18n.js
  Description: i18n configuration file. Imports i18n data.
  ----------------------------------------------------------------------------------------
   
==========================================================================================*/


import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { fillLang } from '@/utils'

Vue.use(VueI18n)



export default new VueI18n({
  locale: localStorage.getItem('locale') || 'zh', // set default locale

  // 指定某个语言包为基础包，当某个语言包的某个字段缺失，使用基础语言包填充
  // !!!!基础语言包必须是最完整的!!!!
  // 这里选择中文语言包为基础包
  messages: fillLang('zh',{
    en: require('./lang/en').default,
    zh: require('./lang/zh').default,
  }),
})
